
import { VAutocomplete } from "vuetify/lib";

export default VAutocomplete.extend({});
